export default __webpack_public_path__ + "static/truncation-dont-34b3f470241d972fee7b156f55211689a0df79c241e3c04d5422acc7c1bf8c75.png";